export default __webpack_public_path__ + "static/media/linkedin.13eac042.svg";